import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { obtenerListaClientesPorEmpresa } from "../../../../store/Empresa/thunkEmpresa";
import { NavLink } from "react-router-dom";

export const Clientes = ({ clientes }) => {
    const dispatch = useDispatch();
    const [empresaDetails, setEmpresaDetails] = useState([]); // Estado inicializado como array
    const [searchTerm, setSearchTerm] = useState(""); // Estado para el término de búsqueda

    const fetchempresaDetails = useCallback(
        async (id_empresa) => {
            try {
                // Llama a la acción 'listadeclientesporempresa' y actualiza el estado 'empresaDetails'.
                const empresaData = await dispatch(obtenerListaClientesPorEmpresa(id_empresa));
                setEmpresaDetails(empresaData); // Guarda los detalles de la empresa en el estado para su uso posterior.
            } catch (error) {
                console.error("Error al obtener los detalles de la empresa:", error); // Manejo de errores
            }
        },
        [dispatch],
    );

    useEffect(() => {
        // Ejecuta la función 'fetchempresaDetails' al cargar el componente si 'id_empresa' está presente
        if (clientes?.id_empresa > 0) {
            fetchempresaDetails(clientes.id_empresa);
        }
    }, [clientes, fetchempresaDetails]); // Se ejecuta nuevamente cuando 'clientes' cambia

    // Filtrar los clientes según el término de búsqueda
    const filteredClientes = empresaDetails.filter((entry) => entry.nombre_cliente?.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h5>Lista completa de clientes</h5>
                </div>
                <div className="card-body">
                    <p className="mb-0">Todos los clientes relacionados a esta empresa.</p>
                </div>
            </div>

            <div className="card">
                <div className="card-header">
                    <h5>Clientes</h5>
                </div>
                <div className="card-body">
                    <div className="row">
                        {/* Input de búsqueda */}
                        <input type="text" placeholder="Buscar por nombre de cliente" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="form-control mb-3" />

                        {filteredClientes.length > 0 ? (
                            filteredClientes.map((entry, idx) => (
                                <div className="col-xl-4 col-sm-6" key={idx}>
                                    <NavLink to={`/clientes/perfil?data=${entry.id_cliente}`} className="pc-link active">
                                        <div className="statistics-card-1 card">
                                            <div className="card-header d-flex align-items-center justify-content-between py-3">
                                                <h5>{entry.nombre_cliente || "Nombre no disponible"}</h5>
                                                <div className="flex-shrink-0">
                                                    <img alt="img" loading="lazy" width="92" height="90" decoding="async" data-nimg="1" className="img-fluid wid-80" srcSet="" src="https://light-able-react-light.vercel.app/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fimg-accout-alert.a2294f08.png&w=96&q=75" style={{ color: "transparent" }} />
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <img alt="img" width="63" height="134" decoding="async" data-nimg="1" className="img-fluid img-bg" src="https://light-able-react-light.vercel.app/_next/static/media/img-status-2.4d72f177.svg" style={{ color: "transparent" }} />
                                                <div className="d-flex align-items-center">
                                                    <h5 className="f-w-300 d-flex align-items-center m-b-0">Detalles</h5>
                                                </div>
                                                <p className="text-muted m-b-0">
                                                    <h6 className="mb-0">Correo:</h6> {entry.correo_cleinte || "No especificado"}
                                                </p>
                                                <h6 className="mb-0">Teléfono:</h6> {entry.telefono_cliente || "No disponible"}
                                                <br />
                                                <h6 className="mb-0">Cumpleaños:</h6> {entry.cumpleanos || "No disponible"}
                                                <br />
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            ))
                        ) : (
                            <p>No hay clientes relacionados</p>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
